import React from 'react';
import { styled, useHistory } from 'troyfe';
import { LeftOutlined } from '@ant-design/icons';

const Box = styled.div`
  .pageTop {
    padding: 14px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f1f2f4;

    .back {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 74px;
      height: 38px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #F1F2F4;
      color: #666666;
      font-size: 16px;
    }

    .title {
      font-size: 20px;
      font-weight: 700;
      color: #121212;
    }

    .detailsTitleBtn {
      display: flex;
      position: absolute;
      right: 32px;
      top: 16px;

      button {
        width: 100px;
        height: 48px;
        background: #44bb55;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
`;
export default function PageHeader({ title = '', isBack = false, backFn, rightContent, backUrl = '', noBorder = false }) {
  const history = useHistory();

  return (
    <Box>
      <div style={{ ...(noBorder ? { border: 'none' } : {}) }} className="pageTop">
        <div>
          {isBack && (
            <div
              className="back"
              onClick={() => {
                if (typeof backFn === 'function') return backFn();
                if (backUrl) {
                  history.push({
                    pathname: backUrl,
                  });
                } else {
                  history.goBack();
                }
              }}
            >
              <LeftOutlined style={{ color: '#999', marginRight: '2px' }} />
              返回
            </div>
          )}
        </div>
        <div className="title">{title}</div>
        <div>{rightContent}</div>
      </div>
    </Box>
  );
}
